import { Fragment } from 'react';
import Routes from './routes/routes';

function App() {
  return (
    <Fragment>
      <Routes />
    </Fragment>
  );
}

export default App;
